import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import ShippingFulfillmentSelector from './ShippingFulfillmentSelector'
import * as Styles from './styles'

const ShippingFulfillmentSection = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM">{t('Envío productos')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define si el estado de envío de los productos empaquetados debe actualizarse en el pedido original en tu plataforma de comercio electrónico al preparar los envíos.'
        )}
      </Text>
      <ShippingFulfillmentSelector value={value} onChange={onChange} />
    </Styles.Container>
  )
}

export default ShippingFulfillmentSection
